import { NavLink } from "react-router-dom";

// reactstrap components
import { Container, Row } from "reactstrap";

const PagesFooter = () => {
  return (
    <>
      <footer className="footer footer-white">
        <Container>
          <Row>
            <nav className="footer-nav">
              <ul>
                <li>
                  <NavLink
                    to="/regulaminSerwisu"
                    onClick={() => {
                      window.focus();
                      window.scrollTo(0, 0);
                    }}
                  >
                    Regulamin serwisu
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/privacypolicy"
                    onClick={() => {
                      window.focus();
                      window.scrollTo(0, 0);
                    }}
                  >
                    Polityka prywatności
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/wcag"
                    onClick={() => {
                      window.focus();
                      window.scrollTo(0, 0);
                    }}
                  >
                    Dostępność cyfrowa
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/mapa-strony"
                    onClick={() => {
                      window.focus();
                      window.scrollTo(0, 0);
                    }}
                  >
                    Mapa strony
                  </NavLink>
                </li>
              </ul>
            </nav>
            <div className="credits ml-auto">
              <span className="copyright">&copy; {1900 + new Date().getYear()}, AOTMiT</span>
            </div>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default PagesFooter;
